module.exports = __webpack_public_path__ + "073529030f4eb73db9236ee385d45615.MP3";